import React from "react";
import {
  CURRENT_AOP_COLUMN_LABEL,
  getCurrentAopMembershipLabel,
} from "../shared/utils/currentAopByProgram";

/**
 * Display-only Current AOP membership badge (Yes / No).
 * Yes = program has a Current-FY SOP row; No = outside Current AOP.
 *
 * @param {{ inCurrentAop: boolean|null|undefined, className?: string }} props
 */
export default function CurrentAopStatus({ inCurrentAop = null, className = "" }) {
  const statusLabel = getCurrentAopMembershipLabel(inCurrentAop);
  const tone =
    inCurrentAop == null ? "unknown" : inCurrentAop ? "yes" : "no";
  const rootClass = [
    "current-aop-status",
    `current-aop-status--${tone}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <span
      className={rootClass}
      role="status"
      aria-label={`${CURRENT_AOP_COLUMN_LABEL}: ${statusLabel}`}
    >
      {statusLabel}
    </span>
  );
}
